import React, { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { CreditCard } from "@phosphor-icons/react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Starts a Stripe Checkout session for the given package_id and redirects.
 * Usage: <PayButton packageId="basic_tuneup">Pay $79</PayButton>
 */
export default function PayButton({
  packageId,
  children,
  className = "",
  variant = "primary",
  testId,
}) {
  const [loading, setLoading] = useState(false);

  const base =
    "inline-flex items-center justify-center gap-2 rounded-full font-semibold transition-all disabled:opacity-60";
  const styles =
    variant === "primary"
      ? "bg-blue-600 hover:bg-blue-700 text-white blue-glow"
      : variant === "dark"
      ? "bg-zinc-900 hover:bg-zinc-800 text-white"
      : "bg-white hover:bg-zinc-50 text-zinc-900 border border-zinc-300";

  const onClick = async () => {
    setLoading(true);
    try {
      const origin = window.location.origin;
      const r = await axios.post(`${API}/payments/checkout`, {
        package_id: packageId,
        origin_url: origin,
      });
      if (r.data?.url) {
        window.location.href = r.data.url;
      } else {
        throw new Error("No checkout URL");
      }
    } catch (err) {
      const detail = err?.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Couldn't start checkout. Please try again.");
      setLoading(false);
    }
  };

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={loading}
      data-testid={testId || `pay-${packageId}`}
      className={`${base} ${styles} ${className}`}
    >
      <CreditCard size={16} weight="duotone" />
      {loading ? "Redirecting…" : children}
    </button>
  );
}
